var React = require('react');

function EmptyCheck (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M59.5886 30.0095V32.5012C59.5852 38.3415 57.6941 44.0243 54.1972 48.702C50.7002 53.3796 45.7849 56.8016 40.1843 58.4576C34.5837 60.1135 28.5978 59.9147 23.1194 57.8907C17.641 55.8667 12.9636 52.126 9.78489 47.2266C6.60614 42.3271 5.09631 36.5313 5.48058 30.7037C5.86486 24.876 8.12264 19.3287 11.9172 14.8891C15.7118 10.4494 20.8398 7.35534 26.5366 6.06824C32.2333 4.78114 38.1934 5.37001 43.5281 7.74701","stroke":"#14AA69","strokeWidth":"5.41667","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M59.5833 10.8359L32.5 37.9464L24.375 29.8214","stroke":"#14AA69","strokeWidth":"5.41667","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

EmptyCheck.defaultProps = {"width":"65","height":"65","viewBox":"0 0 65 65","fill":"none"};

module.exports = EmptyCheck;

EmptyCheck.default = EmptyCheck;
